import { CheckboxCard } from "shared/components/forms/CheckboxCard";

export const YesNoWidget = () => {
  return (
    <div className="flex gap-2 items-center w-full">
      <CheckboxCard
        id="yes"
        name="yes"
        onChange={() => {
          //
        }}
        label="Yes"
        wrapperClassName="w-full"
      />

      <CheckboxCard
        id="no"
        name="no"
        onChange={() => {
          //
        }}
        label="No"
        wrapperClassName="w-full"
      />
    </div>
  );
};
